"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _RemoveMembershipModal = _interopRequireDefault(require("./RemoveMembershipModal"));

var _UsersListItem = _interopRequireDefault(require("./UsersListItem"));

var _utils = require("../../../../../common/utils");

require("../styles/_users-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MODAL = {
  REMOVE_USER: 'REMOVE_USER',
  RESET_CREDENTIALS: 'RESET_CREDENTIALS'
};
var STATUS_FILTER_ITEMS = [{
  label: 'ALL USERS',
  value: void 0
}, {
  label: 'ACTIVE',
  value: 'ACCEPTED'
}];
var filters = {
  status: STATUS_FILTER_ITEMS
};

var UsersList = /*#__PURE__*/function (_Component) {
  _inherits(UsersList, _Component);

  function UsersList() {
    var _this;

    _classCallCheck(this, UsersList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UsersList).call(this));

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _lodash.default)(function (_ref) {
      var member = _ref.member,
          modalName = _ref.modalName;
      return function () {
        _this.setState({
          modalMember: member,
          openedModal: modalName
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "gotoUser", (0, _lodash.default)(function (userId) {
      return function () {
        var history = _this.props.history;
        history.rootPush("/user-settings/edit/".concat(userId));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "getActionOptions", (0, _lodash.default)(function (member) {
      var orgPermissions = _this.props.orgPermissions;
      var memberAccepted = member.status === 'ACCEPTED' && Boolean(member.user);
      var actionOptions = [{
        action: function action() {
          return _this.ghostUser(member.user);
        },
        label: 'GHOST THIS USER',
        requiredPermission: ['MANAGE_CUSTOMERS']
      }, {
        action: _this.openModal({
          member: member,
          modalName: MODAL.RESET_CREDENTIALS
        }),
        label: 'RESET CREDENTIALS'
      }, {
        action: _this.openModal({
          member: member,
          modalName: MODAL.REMOVE_USER
        }),
        label: 'REMOVE FROM TEAM',
        isRed: true,
        requiredPermission: ['MANAGE_ORGANISATION', 'MANAGE_TEAM']
      }];

      if (memberAccepted) {
        actionOptions.splice(0, 0, {
          action: _this.gotoUser(member.user && member.user.userId),
          label: 'VIEW DETAILS'
        });
      }

      return actionOptions.filter(function (_ref2) {
        var requiredPermission = _ref2.requiredPermission;
        return !requiredPermission || requiredPermission.every(function (permission) {
          return (0, _commonReact.hasPermission)(permission, orgPermissions);
        });
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "handleResetCredential", (0, _lodash.default)(function (user) {
      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var forgotPassword, _ref4, error;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  forgotPassword = _this.props.forgotPassword;

                  if (user) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt("return");

                case 3:
                  _context.next = 5;
                  return forgotPassword(user.email);

                case 5:
                  _ref4 = _context.sent;
                  error = _ref4.error;

                  if (!error) {
                    _context.next = 9;
                    break;
                  }

                  return _context.abrupt("return");

                case 9:
                  _this.closeModal();

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      );
    }));

    _defineProperty(_assertThisInitialized(_this), "ghostUser", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(user) {
        var _this$props, ghostStart, history;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = _this.props, ghostStart = _this$props.ghostStart, history = _this$props.history;
                _context2.next = 3;
                return (0, _utils.ghostUserInvoker)({
                  ghostStart: ghostStart,
                  user: user,
                  history: history
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        openedModal: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (membership) {
      var _this$props2 = _this.props,
          teamRoles = _this$props2.teamRoles,
          orgPermissions = _this$props2.orgPermissions,
          teamName = _this$props2.teamName,
          handleRoleChange = _this$props2.handleRoleChange;
      var openedModal = _this.state.openedModal;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UsersListItem.default, {
        membership: membership,
        teamRoles: teamRoles,
        teamName: teamName,
        updateMembershipRole: handleRoleChange(membership.teamMembershipId),
        actionOptions: _this.getActionOptions(membership),
        hasManagePermission: (0, _commonReact.hasPermission)('MANAGE_ORGANISATION', orgPermissions) && (0, _commonReact.hasPermission)('MANAGE_TEAM', orgPermissions)
      }), _react.default.createElement(_uiKit.FormModal, {
        visible: openedModal === MODAL.RESET_CREDENTIALS,
        onClose: _this.closeModal,
        title: "Reset Credentials?",
        saveText: "RESET",
        onSave: _this.handleResetCredential(membership.user)
      }));
    });

    _this.state = {
      modalMember: void 0,
      openedModal: void 0
    };
    return _this;
  }

  _createClass(UsersList, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          history = _this$props3.history,
          teamName = _this$props3.teamName,
          userListLoading = _this$props3.userListLoading,
          userListError = _this$props3.userListError,
          teamMemberships = _this$props3.teamMemberships,
          onMembershipDeleted = _this$props3.onMembershipDeleted,
          handleFiltersChange = _this$props3.handleFiltersChange;
      var _this$state = this.state,
          modalMember = _this$state.modalMember,
          openedModal = _this$state.openedModal;

      if (userListError) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      return _react.default.createElement("div", {
        className: "users-list"
      }, _react.default.createElement(_RemoveMembershipModal.default, {
        visible: openedModal === MODAL.REMOVE_USER,
        teamName: teamName,
        onClose: this.closeModal,
        onMembershipDeleted: onMembershipDeleted,
        membership: modalMember
      }), _react.default.createElement(_uiKit.List, {
        history: history,
        loading: userListLoading,
        data: teamMemberships,
        listKey: "teamMembershipId",
        filters: filters,
        onFiltersChange: handleFiltersChange,
        renderListItem: this.renderListItem
      }));
    }
  }]);

  return UsersList;
}(_react.Component);

exports.default = UsersList;